export default {
  global: {
    body: {
      bg: `#929292`,
    },
  },
}
